export default __webpack_public_path__ + "static/media/Tiktok.d49a475e.svg";